'use client';

import { Dialog, DialogContent } from '#/components/ui/dialog';
import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { useConfiguredChainId } from '#/data/wagmi/configured';
import { executionWithdrawalConfig } from '#/lib/generated';
import { handleTransactionError } from '#/lib/handle-transaction-error';
import { DialogContentProps, DialogProps } from '@radix-ui/react-dialog';
import { captureException } from '@sentry/nextjs';
import { useActor, useInterpret } from '@xstate/react';
import invariant from 'invariant';
import {
  concat,
  formatEther,
  padHex,
  parseEther,
  parseUnits,
  toHex,
} from 'viem';
import { useSendTransaction } from 'wagmi';
import machine, { MachineContext } from './contexts/machine';
import { Information } from './information';

interface Props {
  originalRow: EthereumStakingValidatorInfo;
}
function DialogContentImpl({ originalRow }: Props) {
  const chainId = useConfiguredChainId();
  const {
    sendTransactionAsync,
    data: transactionHash,
    isSuccess,
    isPending,
  } = useSendTransaction();

  const interpreter = useInterpret(machine, {
    context: {
      originalRow,
    },
    services: {
      onTransaction: async (context, event) => {
        console.log('====================================');
        console.log('onTransaction', context);
        console.log('====================================');
        const { originalRow, amount } = context;
        console.log('====================================');
        console.log('onTransaction', {
          originalRow,
          amount,
        });
        console.log('====================================');
        invariant(originalRow != null, 'target is required');
        invariant(amount != null && amount != BigInt(0), 'amount is required');

        try {
          const gweiAmount = parseEther(formatEther(amount), 'gwei');

          const data = concat([
            originalRow.pubKey,
            padHex(toHex(gweiAmount), { size: 8 }),
          ]);

          const transactionHash = await sendTransactionAsync({
            to: executionWithdrawalConfig.address(chainId),
            value: parseUnits('1', 0), // 1wei
            data,
          });

          console.log('====================================');
          console.log('Transaction Success', transactionHash);
          console.log('====================================');

          return { transactionHash };
        } catch (error) {
          handleTransactionError(error);
          captureException(error);
          throw error;
        }
      },
    },
  });
  const [state, dispatch] = useActor(interpreter);

  return (
    <MachineContext.Provider value={interpreter}>
      <Information />
    </MachineContext.Provider>
  );
}
export function PartialWithdrawalDialogContent({
  originalRow,
}: Props & DialogContentProps) {
  return (
    <DialogContent className="sm:max-w-(--breakpoint-sm) overflow-y-scroll max-h-screen">
      <DialogContentImpl originalRow={originalRow} />
    </DialogContent>
  );
}
export function PartialWithdrawalDialog({
  originalRow,
  ...props
}: Props & DialogProps) {
  return (
    <Dialog {...props}>
      <PartialWithdrawalDialogContent originalRow={originalRow} />
    </Dialog>
  );
}
